import { render, staticRenderFns } from "./deals-loader.vue?vue&type=template&id=4a7215ff"
import script from "./deals-loader.vue?vue&type=script&lang=js"
export * from "./deals-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports